import React, { Component } from 'react'
import axios from 'axios';
import Papa from 'papaparse';
import { Notifications } from '../../../common/notification';
import Select from 'react-select';
import { BILLING_CREATED, CARRIER_RATEDECK_UPLOAD, LOGIN_URL } from '../../../../config/rest_endpoints';
import { getUser } from '../../../../actions/session';
import { Redirect } from 'react-router-dom';
// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";

export class AddRateDeckCarrier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            charges: '0',
            rates: '',
            selectedCharges: { value: '6s', label: '6s' },
            selectedtype: '',
            optionsConnectCharges: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '24s', label: '24s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            optionsAccountType: [
                { value: 'Postpay', label: 'Postpay' },
                { value: 'Prepay', label: 'Prepay' }
            ],
            roundMethod: [
                { value: '*up', label: 'Up' },
                { value: '*down', label: 'Down' }
            ],
            selectRoundMethod: { value: '*up', label: 'Up' },
            roundDigits: [
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' }
            ],
            selectRoundDigits: { value: 4, label: '4' },
            subsequent: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            subsequentSelect: { value: '6s', label: '6s' },
            billList: [],
            selectFile: null,
            msg: '',
            isSpin: false,
            id: '',
            name: '',
            routeCode: '',
            routeCodeOption: [],
            interState: '',
            interStateOption: [],
            intraState: '',
            intraStateOption: [],
            interminate: '',
            interminateOption: [],
            nxx: '',
            nxxOption: [],
            startDate: new Date(),
            UId: '',
            isDataTable: false,
            newTable: {},
            isUploading: false,
            progress: 0,
            timer: 0,
            isFormShow: false,
            readContent: null,
            isNPPACheck: false,
            carrierID: '',
            isClearable: false,
            duplicateContent: []


        }
        this.handleSelectAccount = this.handleSelectAccount.bind(this)
        this.handleSelectCharges = this.handleSelectCharges.bind(this)
        this.onHandleChange = this.onHandleChange.bind(this)
        this.onSubmitBill = this.onSubmitBill.bind(this)
        this.handleRoundDigitsSelect = this.handleRoundDigitsSelect.bind(this)
        this.handleRoundMethodSelect = this.handleRoundMethodSelect.bind(this)
        this.handleSubsequentSelect = this.handleSubsequentSelect.bind(this)
        this.handleFileUpload = this.handleFileUpload.bind(this)
        this.handleRouteCode = this.handleRouteCode.bind(this)
        this.handleInterStateHdr = this.handleInterStateHdr.bind(this)
        this.handleInterminuteHdr = this.handleInterminuteHdr.bind(this)
        this.handleIntraStateHdr = this.handleIntraStateHdr.bind(this)
        this.handleDate = this.handleDate.bind(this)
        this.filterPassedTime = this.filterPassedTime.bind(this)
        this.handleUploadFile = this.handleUploadFile.bind(this)
        this.setInputValues = this.setInputValues.bind(this)
        this.handleNPPACheck = this.handleNPPACheck.bind(this)
        this.handleNxx = this.handleNxx.bind(this)

    }

    componentWillReceiveProps(newProps) {
        this.setState({
            isDataTable: newProps.clearModal,
            carrierID: newProps.id,
            isClearable: newProps.clearState
        })
    }

    filterPassedTime(time) {
        let currentTime = time.getTime()
        const currentDate = new Date();
        const selectedDate = new Date(currentTime);
        let givenTime = currentDate.getTime() - selectedDate.getTime();
        return givenTime
    }

    componentDidMount() {

    }

    handleNPPACheck() {
        this.setState({ isNPPACheck: !this.state.isNPPACheck })
    }

    handleDate(startDate) {
        this.setState({
            startDate
        }, () => {
        })
    }
    onHandleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleFileUpload(e) {
        this.setState({ selectFile: e.target.files[0], isUploading: true }, () => {
            setInterval(() => {
                let { timer } = this.state;
                if (timer < 100) {
                    timer += 10;
                    this.setState({
                        timer: timer
                    });
                }
            }, 80);
            this.handleUploadFile()
        })
    }

    handleSelectCharges(selectedCharges) {
        this.setState({ selectedCharges });
    };

    handleSelectAccount(selectedtype) {
        this.setState({ selectedtype });
    };

    handleSubsequentSelect(subsequentSelect) {
        this.setState({ subsequentSelect })
    }

    handleRoundMethodSelect(selectRoundMethod) {
        this.setState({ selectRoundMethod })
    }

    handleRoundDigitsSelect(selectRoundDigits) {
        this.setState({ selectRoundDigits })
    }

    handleRouteCode(routeCode) {
        const { duplicateContent } = this.state
        duplicateContent.push(routeCode)
        this.setState({ routeCode }, () => {
            // this.setInputValues()
        })
    }

    handleInterStateHdr(interState) {
        const { duplicateContent } = this.state
        duplicateContent.push(interState)
        this.setState({ interState }, () => {
            // this.setInputValues()
        })
    }

    handleIntraStateHdr(intraState) {
        const { duplicateContent } = this.state
        duplicateContent.push(intraState)
        this.setState({ intraState }, () => {
            // this.setInputValues()
        })
    }

    handleInterminuteHdr(interminate) {
        const { duplicateContent } = this.state
        duplicateContent.push(interminate)
        this.setState({ interminate }, () => {
            // this.setInputValues()
        })
    }

    handleNxx(nxx) {
        this.setState({ nxx })
    }

    clearState() {
        this.setState({
            charges: '0',
            selectedCharges: { value: '6s', label: '6s' },
            selectRoundMethod: { value: '*up', label: 'Up' },
            selectRoundDigits: { value: 4, label: '4' },
            subsequentSelect: { value: '6s', label: '6s' },
            routeCode: { value: 'NPANXX', label: 'NPANXX' },
            interState: { value: 'Interstate', label: 'Interstate' },
            intraState: { value: 'Interstate', label: 'Interstate' },
            interminate: { value: 'Indeterminate', label: 'Indeterminate' },
            startDate: new Date(),
            selectFile: null,
            isUploading: false,
            progress: 0,
            timer: 0,
            isFormShow: false,
            readContent: null,
            isClearable: false
        })
    }


    onSubmitBill() {
        const { User, routeCode, interState, isNPPACheck, nxx, startDate, intraState, interminate, carrierID, userId, charges, rates, selectedCharges, subsequentSelect, selectRoundMethod, selectRoundDigits, selectFile, isSpin } = this.state
        console.log('startDate', startDate)
        const payload = {
            "carrierID": carrierID,
            "name": "rscom",
            "connectFee": parseInt(charges),
            "initialInc": selectedCharges.value,
            "subsequentInc": subsequentSelect.value,
            "roundingMethod": selectRoundMethod.value,
            "roundingDigits": selectRoundDigits.value,
            "routeCodeHdr": routeCode.value,
            "interstateHdr": interState.value,
            "intrastateHdr": intraState.value,
            "indeterminateHdr": interminate.value,
            "effectiveDate": Math.floor(startDate.toDate().getTime() / 1000.0),
            "isNPANXXSplit": isNPPACheck,
            "nxxHdr": isNPPACheck ? nxx.value : ''
        }

        console.log('payload', payload)
        const data = new FormData()
        data.append('file', selectFile)
        data.append('request', JSON.stringify(payload))


        var headers = { 'Authorization': "Bearer " + User.token }
        this.setState({ isSpin: true })
        axios.post(CARRIER_RATEDECK_UPLOAD, data, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                this.setState({
                    msg: res.data.message,
                    isSpin: false,
                    isDataTable: true,
                    newTable: resp,
                    isUploading: false,
                    isFormShow: false
                })
                this.clearState()
                // this.props.listing()
                Notifications.notify(this.state.msg, "Created", "success")
            }

        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
                isSpin: false
            })
        })
    }

    handleUploadFile() {
        const { selectFile } = this.state
        setTimeout(() => {
            this.setState({ isFormShow: true })
        }, 1000)
        Papa.parse(selectFile, {
            preview: 1,
            complete: (results) => {
                if (results.data && results.data.length > 0) {
                    this.setState({ readContent: results.data[0] }, () => {
                        this.setInputValues()
                    })
                }
            }
        })
    }

    setInputValues() {
        const { readContent, duplicateContent } = this.state
        const getVals = readContent.map(val => val.trim())
        const dupl = duplicateContent.map(item => item['value'])

        const dropDownValues = getVals.filter(item => {
            if (!dupl.length) {
                return true
            }
            return !dupl.includes(item)
        }).map(row => {
            return {
                'label': row,
                'value': row
            }
        })

        const interMinateValue = [
            ...dropDownValues,
            { label: 'DO NOT ROUTE IJ', value: 'DO NOT ROUTE IJ' },
            { label: 'Highest of Inter/Intra', value: 'Highest of Inter/Intra' },
            { label: 'Lowest of Inter/Intra', value: 'Lowest of Inter/Intra' }
        ]

        this.setState({
            routeCodeOption: dropDownValues,
            interminateOption: interMinateValue
        })
    }


    handleResTable() {
        const { newTable, duplicateContent, interminateOption } = this.state
        console.log(`newTable`, newTable)
        return (
            <div>
                <h5>
                    <i className="icon-file-presentation mr-2"></i>
                    <span className="font-weight-semibold">Stats</span><b>{newTable.heading}</b>
                    {/* <small className="d-block text-muted">Transparent background color</small> */}
                </h5>

                <table className="table datatable-basic bg-light table-bordered dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Records In Files</th>
                            <th>Record Import into System</th>
                            <th></th>
                            <th></th>
                            <th>Interstate</th>
                            <th>Intrastate</th>

                            {/* <th>Interstate Decrease</th>
                            <th>Interstate Increase</th>
                            <th>Interstate Same</th>
                            <th>Intrastate Decrease</th>
                            <th>Intrastate Increase</th>
                            <th>Intrastate Same</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>

                            <td>
                                <span className="badge badge-primary">Total</span>
                            </td>
                            <td>{newTable.total}</td>
                            <td></td>
                            <td></td>
                            <td><b>New</b></td>
                            <td>{newTable.newCount}</td>
                            <td>{newTable.newCount}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="badge badge-success">Correct</span>
                            </td>
                            <td>{newTable.correct}</td>
                            <td>{newTable.correct}</td>
                            <td></td>
                            <td><b>Same</b></td>
                            <td>{newTable.interstateSame}</td>
                            <td>{newTable.intrastateSame}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="badge badge-danger">Failed</span>
                            </td>
                            <td>{newTable.incorrect}</td>
                            <td></td>
                            <td></td>
                            <td><b>Increase</b></td>
                            <td>{newTable.interstateIncrease}</td>
                            <td>{newTable.intrastateIncrease}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="badge badge-secondary">Duplicate</span>
                            </td>
                            <td>{newTable.duplicate}</td>
                            <td></td>
                            <td></td>
                            <td><b>Decrease</b></td>
                            <td>{newTable.interstateDecrease}</td>
                            <td>{newTable.intrastateDecrease}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className="badge badge-warning">Negative</span>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><b>Removed</b></td>
                            <td>{newTable.missing}</td>
                            <td>{newTable.missing}</td>
                        </tr>
                        {/* <tr>
                            <td>{newTable.interstateDecrease}</td>
                            <td>{newTable.interstateIncrease}</td>
                            <td>{newTable.interstateSame}</td>
                            <td>{newTable.intrastateDecrease}</td>
                            <td>{newTable.intrastateIncrease}</td>
                            <td>{newTable.intrastateSame}</td>
                        </tr> */}
                    </tbody>
                </table>
                <div class="flex-fill mt-2">
                <span className="font-weight-semibold">Zero Rates : </span><b> {newTable.zeroRates}</b>
                </div>
                {/* <table className="table datatable-basic bg-light table-bordered dataTable no-footer mt-4" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr>
                            <th>Compare RateDeck</th>
                            <th>Incorrect</th>
                            <th>Missing</th>
                            <th>New Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td>{newTable.comparedRatedeck}</td>
                            <td>{newTable.incorrect}</td>
                            <td>{newTable.missing}</td>
                            <td>{newTable.newCount}</td>
                        </tr>
                    </tbody>
                </table> */}
            </div>

        )
    }


    render() {
        const { isDataTable, subsequentSelect, subsequent, selectRoundDigits, duplicateContent, roundDigits, selectRoundMethod, roundMethod, charges, isSpin, rates, selectedOption, optionsConnectCharges, optionsAccountType, selectedCharges, selectedtype, billList, isGetting, isError } = this.state

        if (this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }
        return (
            <div>
                {isDataTable ? this.handleResTable() :
                    <div>
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>File Upload:</label>
                                    <div className="uniform-uploader"><input type="file" accept=".csv" onChange={this.handleFileUpload} className="form-input-styled" data-fouc="" /><span className="filename" style={{ userSelect: 'none' }}>{this.state.selectFile === null ? 'no file is selected' : this.state.selectFile.name}</span><span className="action btn btn-success btn-sm main-button" style={{ userSelect: 'none' }}>Browser</span></div>
                                    <span className="form-text text-muted">Accepted formats: csv. Max file size 2Mb</span>
                                </div>
                            </div>
                            {this.state.isUploading ?
                                <div className="col-md-12">
                                    <div className="progress" style={{ height: '1.5rem' }}>
                                        <div className="progress-bar border bg-light" style={{ width: '100%' }}>
                                            {/* <span className="sr-only">60% Complete</span> */}
                                            <span className="styles" style={{ background: '#607d8b', width: this.state.timer * 1 + "%" }}>
                                                {this.state.timer}
                                            </span>
                                        </div>
                                        {/* <button onClick={this.handleUploadFile}>Click me!</button> */}
                                    </div>
                                </div>
                                : ''}

                        </div>
                        {this.state.isFormShow ?
                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Route Code Header <span class="text-muted "> (Example of NPANXX)</span></label>
                                            <Select
                                                value={this.state.routeCode}
                                                onChange={this.handleRouteCode}
                                                options={this.state.routeCodeOption}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                        <label>Interstate Header</label>
                                            <Select
                                                value={this.state.interState}
                                                onChange={this.handleInterStateHdr}
                                                options={this.state.routeCodeOption}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Intrastate Header</label>
                                            <Select
                                                value={this.state.intraState}
                                                onChange={this.handleIntraStateHdr}
                                                options={this.state.routeCodeOption}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Indeterminate Header</label>
                                            <Select
                                                value={this.state.interminate}
                                                onChange={this.handleInterminuteHdr}
                                                options={this.state.interminateOption}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div class="custom-control custom-checkbox mb-2">
                                            <input type="checkbox" class="custom-control-input" onChange={this.handleNPPACheck} id="isNPPACheck" checked={this.state.isNPPACheck} />
                                            <label class="custom-control-label" for="isNPPACheck">Check if NPA and NXX are split into two fields</label>
                                        </div>
                                    </div>

                                    {this.state.isNPPACheck ?
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>NXX</label>
                                                <Select
                                                    value={this.state.nxx}
                                                    onChange={this.handleNxx}
                                                    options={this.state.routeCodeOption}
                                                />
                                            </div>
                                        </div>
                                        : ''}
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Connect Charges</label>
                                            <input type="number" className="form-control" name="charges" value={charges} onChange={this.onHandleChange} placeholder="Enter charges" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Effective Date<span className="text-muted "> Local System Time-zone</span></label>
                                            <DateRangePicker
                                            onCallback={(date) => this.handleDate(date, "start")}
                                            initialSettings={{
                                            singleDatePicker: true,
                                            timePicker: true,
                                            showDropdowns: true,
                                            startDate: moment(this.state.startDate),
                                            locale: {
                                                format: 'MMMM/DD/YYYY h:mm A',
                                            },
                                            drops:'up'
                                            }}
                                            
                                            >
                                            <input type="text" className="form-control" style={{ minWidth: '300px' }} />
                                            </DateRangePicker>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-6">
                        <div className="form-group">
                            <label>Rate Per Minute</label>
                            <input type="number" className="form-control" name="rates" value={rates} onChange={this.onHandleChange} placeholder="Enter charges" />
                        </div>
                    </div> */}
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Initial Increment</label>
                                            <Select
                                                value={selectedCharges}
                                                onChange={this.handleSelectCharges}
                                                options={optionsConnectCharges}
                                                menuPlacement="top"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Subsequent Increment</label>
                                            <Select
                                                value={subsequentSelect}
                                                onChange={this.handleSubsequentSelect}
                                                options={subsequent}
                                                menuPlacement="top"
                                            />
                                        </div>
                                    </div>


                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Rounding Method</label>
                                            <Select
                                                value={selectRoundMethod}
                                                onChange={this.handleRoundMethodSelect}
                                                options={roundMethod}
                                                menuPlacement="top"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Rounding Digits</label>
                                            <Select
                                                value={selectRoundDigits}
                                                onChange={this.handleRoundDigitsSelect}
                                                options={roundDigits}
                                                menuPlacement="top"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{borderTop:'1px solid #e9ecef'}}>
                                    <div className="col-md-6 ml-auto">
                                        <button type="submit" className="mt-2 main-button btn btn-sm btn-success float-right" disabled={isSpin ? true : false} onClick={this.onSubmitBill} >Submit Ratedeck {isSpin ? <i className="icon-spinner4 spinner ml-2"></i> : <i className="icon-coins ml-2"></i>}</button>
                                    </div>
                                </div>
                            </div>
                            : ''}
                    </div>
                }
            </div>
        )
    }
}

export default AddRateDeckCarrier
